  <uniges-template>
    <ng-container *templateContent>
      <router-outlet></router-outlet>
    </ng-container>
  </uniges-template>

